import React from "react";
import VehicleDetailCard from "../VehicleDetailCard/index";
import VehicleTable from "../VehicleTable";
import { useStyles } from "./styles";

const ContentLayout = () => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.detailSection}>
        <VehicleDetailCard />
      </div>
      <div className={styles.tableSection}>
        <VehicleTable />
      </div>
    </div>
  );
};

export default ContentLayout;
